import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ConfirmationService} from 'primeng/api';
import {ObjectBaseComponent} from '../../../../../core/shared/object/mvs-object-base/object-base.component';
import {NavigationItem} from '../../../../../core/shared/dto/navigation/navigation-item';
import {WidgetData} from '../../../../../core/shared/widget/widget-data';
import {WidgetFactory} from '../../../../../core/shared/widget/service/widget.factory';
import {FilterCriteria} from '../../../../../core/shared/filter/api/filter.criteria';
import {MvsCoreService} from '../../../../../core/shared/service/mvs-core.service';
import {MvsMessageService} from '../../../../../core/shared/service/message/mvs-message.service';
import {ObserverService} from '../../../../../core/shared/object/service/observer.service';
import {Sorting} from '../../../../../core/shared/misc/sorting';
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from '../../../../../core/shared/helper/widget-function-call-back-create';

@Component({
    selector: 'mvs-sp-board-template-object-component',
    templateUrl: './sp-board-template-object.component.html',
    styleUrls: ['./sp-board-template-object.component.scss'],
    standalone: false
})
export class SpBoardTemplateObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    /**
    * AI:
    * Status: 'in progress'
    * Type: Widget
    * SubType: Runtime
    * Reason: Board template detail data widget for displaying template information
    */
    templateDataWidget: WidgetData;

    /**
    * AI:
    * Status: 'in progress'
    * Type: Widget
    * SubType: Runtime
    * Reason: Board template lane table widget filtered by template for managing lanes
    */
    laneWidget: WidgetData;

    constructor(
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected confirmationService: ConfirmationService,
        protected observerService: ObserverService
    ) {
        super(coreService, messageService, confirmationService, observerService);
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    onObjectChanged() {
        this.setupNavigationItems();
        this.refreshComponent();
    }

    refreshComponent() {
        if (!this.objectIdentifier) {
            return;
        }

        this.loadWidgets();
        this.initialized = true;
    }

    setupNavigationItems() {
        const navItems: NavigationItem[] = [
            {
                label: 'Overview',
                action: 'overview',
                tooltip: 'Template Overview',
                icon: 'fa-regular fa-house',
                toggleable: false,
                default: true
            },
            {
                label: 'Lanes',
                action: 'lanes',
                tooltip: 'Template Lanes',
                icon: 'fa-regular fa-layer-group',
                toggleable: false,
                default: false
            }
        ];

        this.onNavigationItems.emit(navItems);
    }

    loadWidgets() {
        const templateId = this.objectIdentifier.objectId;

        /**
        * AI:
        * Status: 'in progress'
        * Type: Widget
        * SubType: Runtime
        * Reason: Board template detail data widget for displaying template information
        */
        this.templateDataWidget = WidgetFactory.createWidgetEntityData(
            'sp.boardTemplate.object.detail.data',
            'Template Details',
            'sp.SpBoardTemplate',
            templateId
        );

        /**
        * AI:
        * Status: 'in progress'
        * Type: Widget
        * SubType: Runtime
        * Reason: Board template lane table widget filtered by template for managing lanes
        */
        this.laneWidget = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
            'sp.boardTemplate.object.lane.table',
            'Template Lanes',
            'sp.SpBoardTemplateLane',
            [FilterCriteria.create('e.boardTemplateId', FilterCriteria.cOperatorEqual, templateId)],
            [new Sorting('e.laneOrder', true)]
        );

        const prefillFields: WidgetToolbarCreateInterface[] = [
            {fieldName: 'boardTemplateDtoId', fieldValue: templateId}
        ];
        this.laneWidget.functionCallbacks =
            WidgetFunctionCallBackCreate.widgetToolbarCreate(prefillFields);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }

        if (changes['objectIdentifier']) {
            this.refreshComponent();
        }
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }
}
